import { Box, Flex } from "@radix-ui/themes";
import { FC, JSX, ReactNode } from "react";

// Full-screen kiosk shell shared by the Samsung Racing screens. Keeps the
// background layers and content padding identical so nothing shifts when the
// kiosk rotates between screens (results <-> next-challenge countdown).
const SamsungScreen: FC<{ children: ReactNode }> = ({
  children,
}): JSX.Element => (
  <Box className="sr-board" height="100vh">
    <Box className="bg-img" />
    <Box className="bg__backdrop-top-left" />
    <Box className="bg__backdrop-top-right" />

    <Flex className="sr-board__inner" direction="column" gap="4" p="5">
      {children}
    </Flex>
  </Box>
);

export default SamsungScreen;
